export const resumeText = (text: string) => {
  if (text.length <= 15) return text;

  const start = text.slice(0, 5);
  const end = text.slice(-5);

  return `${start}...${end}`;
};
